/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import mdClose from '@iconify/icons-ion/md-close';
import { Icon } from '@iconify/react';
import { FormattedMessage, injectIntl } from 'react-intl';

import moment from 'utils/moment';
import styles from './customField.module.scss';
import Clickable from '../clickable/Clickable';
import Modal from '../modal';
import Loading from '../loading';
import tableStyle from '../../styles/general.module.scss';
// eslint-disable-next-line import/no-cycle
import CustomFieldDetail from './CustomFieldDetail';
import { fetchDataSourceFormDetails } from '../../modules/forms/redux/actions';
import Button from '../button/button';
import { renderInfoForType } from '../../utils/helpers';

class FormDataSourceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailModal: false,
      loadingStatus: false,
      isSearch: '',
      isSearchOpen: false
    };
    this.ignoreFields = [
      'multi_field', 'signature', 'attachments', 'map_location', 'ssi_field',
      'header', 'multi_level', 'page_break'
    ];
  }

  componentDidUpdate(prevProps) {
    const { fetchAnswerAction } = this.props;
    if (
      prevProps.fetchAnswerAction?.loading === true
      && fetchAnswerAction?.loading === false
    ) {
      this.setState({ loadingStatus: fetchAnswerAction?.loading });
    }
  }

  handleDetailModal = () => {
    const {
      FormDetailID,
      actionFetchLinkedForms,
      showInLineTable,
      fieldId,
      dataSourceID
    } = this.props;
    localStorage.setItem('fieldId', fieldId);
    let detailId = FormDetailID;
    actionFetchLinkedForms(detailId);
    this.setState({
      loadingStatus: true,
      detailModal: dataSourceID === 'ds6' || !showInLineTable
    });
  }

  render() {
    const {
      link,
      formAnswer,
      dataSourceID,
      FormDetailID,
      answer,
      filters,
      dataSourceValueState,
      handleAnswerForTableSelect,
      fieldId,
      user,
      ds6OrderedTableColumns: ds6OrderedTableColumnsProp,
      getDs6SearchableValues,
      renderDs6PreviewColumnValue,
      getDs6EntrySchema,
      ds6TableViewFields
    } = this.props;

    const ds6OrderedTableColumns = ds6OrderedTableColumnsProp || (dataSourceID === 'ds6' ? [
      { id: '__form_number__', type: 'default' },
      { id: '__created_date__', type: 'default' }
    ] : []);
    const {
      detailModal,
      loadingStatus,
      isSearchOpen,
      isSearch
    } = this.state;
    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <div style={{ display: 'flex' }}>
          {link && (FormDetailID?.length > 0) && (
            <Clickable
              className={styles.detailsLink}
              onClick={this.handleDetailModal}
            >
              <FormattedMessage
                id="roles.privileges.ViewDetails"
                defaultMessage="View Details"
                tagName="p"
              />
            </Clickable>
          )}
          {filters?.show_values?.value === 'table' && (
            <Clickable
              className={styles.detailsLink}
              onClick={() => this.setState({ isSearchOpen: true })}
            >
              <FormattedMessage
                id="topbar.search"
                defaultMessage="Search"
                tagName="p"
              />
            </Clickable>
          )}
        </div>
        {detailModal && formAnswer?.id && (
          <Modal
            width="943px"
            showIn={detailModal}
            onClose={() => this.setState({ detailModal: false })}
            contentStyles={{ overflowY: 'auto', height: '500px' }}
          >
            <div>
              <div className={styles.formDataTitle}>
                <FormattedMessage
                  id="forms.step2.title"
                  defaultMessage="Form Details"
                  tagName="h3"
                />
                <Icon
                  icon={mdClose}
                  onClick={() => this.setState({ detailModal: false })}
                  height="20"
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <div className="container" style={{ marginBottom: '20px' }}>
                <CustomFieldDetail
                  data={formAnswer.data}
                  version={formAnswer.form_version}
                  fields={formAnswer.form_version.schema.fields}
                  downloadBtn
                />
              </div>
            </div>
          </Modal>
        )}
        {isSearchOpen && dataSourceID === 'ds6' && (
          <>
            <Modal
              width="943px"
              showIn={isSearchOpen}
              onClose={() => this.setState({ isSearchOpen: false })}
              contentStyles={{ overflowY: 'auto', height: '500px' }}
            >
              <div className={styles.formDataTitle} style={{ marginBottom: '0px' }}>
                {filters?.form_name}
                <Icon
                  icon={mdClose}
                  onClick={() => this.setState({ isSearchOpen: false })}
                  height="20"
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <div className="container" style={{ marginBottom: '20px' }}>
                <div className={styles.search} style={{ paddingBottom: '20px' }}>
                  <span className={styles.label}>
                    <FormattedMessage
                      id="form.data_source.search"
                      defaultMessage="Search"
                    />
                  </span>
                  <input
                    type="text"
                    name="search"
                    value={isSearch}
                    onChange={e => this.setState({ isSearch: e.target.value })}
                  />
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table className={tableStyle.table} style={{ marginBottom: 0, tableLayout: 'fixed', width: 'max-content' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '100px' }} />
                      {ds6OrderedTableColumns?.map(column => (
                        <th key={column?.id} style={{ width: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {column?.id === '__form_number__' && (
                            <FormattedMessage
                              id="form.list.table.order_number"
                              defaultMessage="Form #" />
                          )}
                          {column?.id === '__created_date__' && (
                            <FormattedMessage
                              id="forms.step2.created_date"
                              defaultMessage="Date" />
                          )}
                          {!['__form_number__', '__created_date__'].includes(column?.id)
                            && column?.title?.substr(0, 50)}
                        </th>
                      ))}
                      </tr>
                    </thead>
                  </table>
                  <div style={{ maxHeight: '300px' }}>
                    <table className={tableStyle.table} style={{ tableLayout: 'fixed', width: 'max-content' }}>
                      <tbody>
                        {dataSourceValueState?.length > 0 ? dataSourceValueState?.filter((val) => {
                          const searchTerm = isSearch?.toLowerCase();
                          if (!searchTerm) return true;

                          if (getDs6SearchableValues) {
                            const valuesToCheck = getDs6SearchableValues(val);
                            return valuesToCheck.some(value => value.includes(searchTerm));
                          }
                          // Fallback
                          const valuesToCheck = [
                            val?.name?.toLowerCase(),
                            ...Object.values(val?.data || {}).map(value => (typeof value === 'string' ? value.toLowerCase() : ''))
                          ];
                          return valuesToCheck.some(value => value.includes(searchTerm));
                        })?.map(entry => (
                          <tr key={entry?.id || entry?.key || entry?.order_number}>
                            <td style={{ paddingRight: '0px', width: '100px' }}>
                              <Button
                                translationID={'sms.formdata.attachhazard'}
                                className={tableStyle.selectbutton}
                                action="secondary"
                                defaultText={entry.key === answer?.detailId ? 'Selected' : 'Select'}
                                onClick={() => {
                                    handleAnswerForTableSelect({ ...entry, value: entry.name, detailKey: entry.key }, fieldId, false);
                                    this.setState({ isSearchOpen: false });
                                  }
                                }
                              />
                            </td>
                            {ds6OrderedTableColumns?.map((column) => {
                              const entrySchema = getDs6EntrySchema
                                ? (getDs6EntrySchema(entry) || { fields: ds6TableViewFields })
                                : { fields: dataSourceValueState?.[0]?.form_version__schema?.fields };
                              return (
                              <td key={column?.id} style={{ width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {column?.id === '__form_number__'
                                  && (entry?.order_number
                                    ? `${moment(entry?.form_date)?.format('YY')} - ${entry?.order_number}`
                                    : '-')}
                                {column?.id === '__created_date__'
                                  ? renderInfoForType({ type: 'datetime' }, entry?.form_date, null, null, false, user)
                                  : null}
                                {!['__form_number__', '__created_date__'].includes(column?.id)
                                  ? (renderDs6PreviewColumnValue
                                      ? renderDs6PreviewColumnValue(
                                          column,
                                          entry?.data?.[column?.id],
                                          { answer_schema: entrySchema },
                                          user
                                        )
                                      : renderInfoForType(
                                          column,
                                          entry?.data?.[column?.id],
                                          { answer_schema: entrySchema },
                                          entrySchema,
                                          false,
                                          user,
                                          false
                                        )) || '-'
                                  : null}
                              </td>
                            );
                            })}
                          </tr>
                        )) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Modal>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  formAnswer:
    get(
      state,
      'forms.linkedFormAnswerDetails'
    ) || {},
  fetchAnswerAction: get(
    state,
    'forms.fetchLinkedAnswerAction'
  ) || {},
  user: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionFetchLinkedForms: (data) => {
    dispatch(fetchDataSourceFormDetails(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(FormDataSourceDetails)
);
